module.exports = __webpack_public_path__ + "static/waleria_01-4aad901f94a951fe2007540002d5cf94.png";